//import React, { Component } from 'react';
import React from 'react';
//import React, {useEffect} from 'react';
//import {Link} from 'react-router-dom';
import Logo_Text from './images/logo_text.png';
import Menu from './navigation/menu';
import Menubottomthankyou from './navigation/menubottomthankyou';
//import Pagination from './navigation/pagination';
//import AccordionInfo from './accordionInfo';
//import { Player } from 'video-react';
import '../node_modules/video-react/dist/video-react.css';


function ThankYou() {


  return (

    <main className="container">
    <div className="logo">
    <br/><br/>
    <img src={Logo_Text} alt="Yari Nanichi-logo" />
    <p><strong>Art To Wear Jewelry</strong></p>
    <br/>
    </div>

    <div className="buttons-bar">
    <Menu/>
    </div>


          <div align="center" className="token_interface">
          <br/>
          <h1>Thank You for your order</h1>
          <p>We will send you the shipping tracking information as soon as
          available.
          </p>
          <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
          </div>


            <div className="buttons-bar">
                <Menubottomthankyou/>
                </div>

                </main>
              );
            }

            export default ThankYou;
